// External libraries
import { action } from 'easy-peasy';

// Internal modules
import { features } from '@/lib/features';
import { CARD_FIELDS_TO_DISPLAY } from './constants';

/**
 * UI MODEL
 * Contains data that relates to the state of the UI
 */
const getUiState = overrides => ({
  // State
  cardFieldsToDisplay: CARD_FIELDS_TO_DISPLAY,
  fiType:
    features.someActive('hasAddBank', 'hasConsumerAddBank') &&
    !features.isActive('isCardTabDefault')
      ? 'bank'
      : 'card',
  hasCardTypeSelector: features.isActive('hasCardTypeSelector'),
  hasCupOneTimePasswordConfirmationMessage: false,
  isAddressNormalizeOpen: false,
  isFormSubmitting: false,
  isInstallmentButtonShown: false,
  isInstallmentInterstitialShown: false,
  isOneTimePasswordConfirmationOpen: false,
  isPageLoading: false,
  isPayWithVenmo: false,
  isPhoneConfirmationOpen: false,
  isSepaInterstitialOpen: false,
  isShippingShown: false,
  isThreeDS1Shown: false,
  isThreeDS2Shown: false,
  multiBrandCardTypes: [],
  pageLevelError: '',
  showCardConversionOptions: false,
  ...overrides,
});

const createUiActions = () => ({
  // Actions
  // eslint-disable-next-line sort-keys
  setCardFieldsToDisplay: action((state, payload) => {
    state.cardFieldsToDisplay = payload;
  }),
  setFiType: action((state, payload) => {
    state.fiType = payload;
  }),
  setHasCardTypeSelector: action((state, payload) => {
    state.hasCardTypeSelector = Boolean(payload);
  }),
  setHasCupOneTimePasswordConfirmationMessage: action((state, payload) => {
    state.hasCupOneTimePasswordConfirmationMessage = Boolean(payload);
  }),
  setIsInstallmentButtonShown: action((state, payload) => {
    state.isInstallmentButtonShown = Boolean(payload);
  }),
  setIsInstallmentInterstitialShown: action((state, payload) => {
    state.isInstallmentInterstitialShown = payload;
  }),
  setIsOneTimePasswordConfirmationOpen: action((state, payload) => {
    state.isOneTimePasswordConfirmationOpen = Boolean(payload);
  }),
  setIsPayWithVenmo: action((state, payload) => {
    state.isPayWithVenmo = Boolean(payload);
  }),
  setIsShippingShown: action((state, payload) => {
    state.isShippingShown = Boolean(payload);
  }),
  setMultiBrandCardTypes: action((state, payload) => {
    state.multiBrandCardTypes = payload;
  }),
  setPageLevelError: action((state, payload) => {
    state.pageLevelError = payload;
  }),
  setShowCardConversionOptions: action((state, payload) => {
    state.showCardConversionOptions = payload;
  }),
  toggleIsAddressNormalizeOpen: action((state, payload) => {
    state.isAddressNormalizeOpen = Boolean(payload);
  }),
  toggleIsFormSubmitting: action((state, payload) => {
    state.isFormSubmitting = Boolean(payload);
  }),
  toggleIsPageLoading: action((state, payload) => {
    state.isPageLoading = Boolean(payload);
  }),
  toggleIsPhoneConfirmationOpen: action((state, payload) => {
    state.isPhoneConfirmationOpen = Boolean(payload);
  }),
  toggleIsSepaInterstitialOpen: action((state, payload) => {
    state.isSepaInterstitialOpen = Boolean(payload);
  }),
  toggleIsThreeDS1Shown: action((state, payload) => {
    state.isThreeDS1Shown = Boolean(payload);
  }),
  toggleIsThreeDS2Shown: action((state, payload) => {
    state.isThreeDS2Shown = Boolean(payload);
  }),
});

const uiModelFactory = () => ({
  ...getUiState(),
  ...createUiActions(),
});

export { getUiState, uiModelFactory };
